
import { useEffect, useState } from "react";
import { Alert, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, responsiveFontSizes } from "@mui/material";
import MDBox from "common/components/MD/MDBox";
import MDInput from "common/components/MD/MDInput";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from 'yup';
import UtilityService from "services/API/utility/UtilityService";
import { InsertEmoticonRounded } from "@mui/icons-material";
import MDButton from "common/components/MD/MDButton";
import MDTypography from "common/components/MD/MDTypography";

import base64ToArrayBuffer from "common/script/base64ToArrayBuffer";









function ModuloEditModal({ onSave, onClose, show,manifestazione,tipo_file}) {


       useEffect(() => {
     setValue("tipo_file",tipo_file)
    }, []);
 
   /* ----------------------------VALIDAZIONE E SALVATAGGIO----------------------------------------------------------------------- */
 
 
     const validationSchema = Yup.object().shape({
         file_allegato: Yup.mixed()
             .required("Devi caricare un file")
             .test("fileSize", "Il file è troppo grande o non c'è!", (file) => {
                 //if u want to allow only certain file sizes
                 return file && file[0] && file[0].size <= 2000000;
             })
 
     });
    const {
        register, //register inputs
        getValues, reset, setValue, control,
        handleSubmit,//handle form submit
        formState: { errors }
    } = useForm({
        resolver: yupResolver(validationSchema),
    });



    //sono quelli lato server
    const [error, setError] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);


    const carica = (formData) => {
        setError(null);
let nf=formData.nome_file;
  if (!nf.endsWith('.pdf')) {
   nf=nf + '.pdf';
  }

        var data = {
            idFile: 0,
            id_manifestazione: manifestazione,
            tipo_file: formData.tipo_file,
            file_allegato: formData.file_allegato,
            nome_file:nf,
            nome_modulo:formData.nome_modulo,

        };
   


           console.log("Inserisci ");
               UtilityService.uploadModulo(data)
                   .then(response => {
                       handleResponse(response);
                   })
                   .catch(errore => {
                          console.log(errore);
                       handleError(errore);
                   });
        
    };

 function handleResponse(response) {
        console.log(response.data);
        //lo aggiungo alla lista
        var inserted = { idFile: response.data.idFile,tipo_file:response.data.tipo_file, nome_file: response.data.nome_file};
        onSave(inserted);
    }

    function handleError(error) {
        setError(error);
        console.log("ERRORE" + error);
        console.log(error.code);
          console.log('Error', error.message);
            setErrorMessage(error.message);

      

    }

    




    return (


        <Dialog open={show} onClose={onClose}
            PaperProps={{
                component: 'form',

            }}  >

            <DialogTitle>Modulo Obbligatorio</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Aggiungi il modulo da compilare selezionando il file dal tuo pc.
                </DialogContentText>
                {error && 
                <Alert>{errorMessage}</Alert>
}
                <MDBox m={2}>
                    <MDInput type="text" label="Tipo Modulo" fullWidth name="tipo_file" disabled
                        {...register('tipo_file')}
                        error={errors.tipo_file ? true : false} InputLabelProps={{ shrink: true }} />
                </MDBox>
              <MDBox m={2}>
                    <MDBox>

                    
                    <MDInput
                        type="text"
                        label="Nome Modulo" fullWidth id="nome_modulo"
                      {...register('nome_modulo')}
                        name="nome_modulo" InputLabelProps={{ shrink: true }}
                    />
                    {
                        errors.nome_modulo ? <span style={{ color: 'red', fontSize: '12px' }}>{errors.nome_modulo?.message}</span> : ''
                    }
                    
                </MDBox>
       
</MDBox>
                <MDBox m={2}>
                    <MDBox>

                    
                    <MDInput
                        type="file"
                        label="File" fullWidth id="file_allegato"
                          {...register('file_allegato')}
                        name="file_allegato" InputLabelProps={{ shrink: true }}
                    />
                    {
                        errors.file_allegato ? <span style={{ color: 'red', fontSize: '12px' }}>{errors.file_allegato?.message}</span> : ''
                    }
                    
                </MDBox>

</MDBox>

<MDBox m={2}>
                    <MDBox>

                    
                    <MDInput
                        type="text"
                        label="Nome File" fullWidth id="nome_file"
                      {...register('nome_file')}
                        name="nome_file" InputLabelProps={{ shrink: true }}
                    />
                    {
                        errors.nome_file ? <span style={{ color: 'red', fontSize: '12px' }}>{errors.nome_file?.message}</span> : ''
                    }
                    
                </MDBox>
       
</MDBox>

                <MDBox ml={2}>


                </MDBox>
            </DialogContent>
            <DialogActions>
                <MDButton onClick={onClose}>Cancel</MDButton>
                <MDButton type="submit" onClick={handleSubmit(carica)}>Upload</MDButton>
            </DialogActions>
        </Dialog>


    );




}
export default ModuloEditModal;